export const getRiskScoreClass = (value: string): string => {
  switch (value) {
    case 'Abstain':
      return 'restricted-text';
    case 'High Risk':
      return 'high-risk-text';
    case 'Medium Risk':
      return 'medium-risk-text';
    case 'Low Risk':
      return 'low-risk-text';
    default:
      return '';
  }
};
